import { BCMSRecord, DisabledPrompt, useBCMSContext, useParams, useRoute } from "@bcm-dev/bcms-vite";
import Classes, { Card, Merchant, Transaction } from "model";
import React from 'react';
import { ImageAsset, SVGAsset } from 'res';
import CustomSelect, { CustomSelectItem } from '../CustomSelect';
import CardImageWidget from "./components/CardImageWidget";
import "./styles.css";

/**
 * @name UICardSelect
 * @function
 * @extends React.Component
 * @exported true
 * @description The main component for a custom select
 * @example 
 *     <UICardSelect cards={cards} value={3}/>
 *  );
 * }
 */
 export default function UICardSelect(props) {
  const globalController = useBCMSContext();
  const defaultCard = globalController.state.branding.options.include_debit_chw23  !== "false" ? "0" : "1";
  const cardID = useParams().cardID ?? defaultCard;
  const showAddCards = globalController.state.branding.options.add_card_chw23  !== "false";
  BCMSRecord.globalControllerFor(Classes, globalController);
  const cards = Card.initAll();
  const navigate = useRoute();  
  let onChange = (value) => { 
          if (value.id){
            navigate(`/home/recentTransactions/${value.id}`);    
          } 
               
  }

  //builds a list of card items for the drop down
  let cardItems = cards.map(card => {
    if(card.name) {
      return <CardSelectItem value={ card } key={ card.id } dataPoint={ "card_select_" + card.id } />
    }
  }, []);
   
  cardItems.unshift(
  <CustomSelectItem close={true} className="account-select-placeholder flex-container flex-horizontal align-center-container clickable flex-width" key="switch">
    <SVGAsset id="FilledCardIcon" className="left-inline-icon switch-card-icon" />
    <span className="set-width">{`Switch${showAddCards ? " or Add Card":" Card"}`} </span>
    <SVGAsset id="UpChevronIcon" className="right-inline-icon chevron-down" />
  </CustomSelectItem>  
)
if(showAddCards){
  cardItems.push(<AddCardSelectItem key="addCard" dataPoint="Add_Card_Select_Item" />)
}
  return (
    //returns a custom select using AccountSelectItem for the items and the AccountSelectedAccount for the selected item view 
    <CustomSelect className="custom-card-select" value={props.card||cards[cardID]} onChange={onChange} SelectedItem={CardSelectedItem} label="" >
        {cardItems}
    </CustomSelect>
  );
}
/**
* @name CardSelectItem
* @function 
* @param {Array} card - account instance
* @extends React.Component
* @exported true
* @description What gets shown in the account select drop down
*/
export function CardSelectItem(props) {
  let card = props.value;
  let dataPoint =  props.dataPoint ? {"data-point":props.dataPoint}:{};
  return (
    <div className="card-select-item custom-card-select-item">
      <CustomSelectItem className="flex-container flex-horizontal align-center-container" value={card}>
        <div className="leftColumn set-width">
          <CardImageWidget card={card} />           
        </div>
        <div className="rightColumn flex-width" {...dataPoint}>
          <span className="card-name">{`${card.type} ${card.maskedNumber}`}</span>
          <span className="card-name sub-text">{`${card.name} `}</span>
        </div>  
      </CustomSelectItem>
    </div>
  );
}
/**
* @name CardSelectedItem
* @function 
* @param {Array} card - card instance
* @extends React.Component
* @exported true
* @description What gets shown for a selected card
*/
export function CardSelectedItem(props) {
  const globalController = useBCMSContext();
  const showAddCards = globalController.state.branding.options.add_card_chw23  !== "false";
  return (
    <div className="flex-container flex-horizontal align-center content-header" data-point="card-select">
      <div onClick={props.controller.toggle} className="account-select-placeholder flex-container flex-horizontal align-center-container clickable flex-width" data-point="Account_Details_Dropdown">
        <SVGAsset id="FilledCardIcon" className="left-inline-icon switch-card-icon" />
        <span className="set-width">{`Switch${showAddCards ? " or Add Card":" Card"}`} </span>
        <SVGAsset id="DownChevronIcon" className="right-inline-icon chevron-down" />
      </div>
    </div>
  );
}

/**
* @name AddCardSelectItem
* @function 
* @param props 
* @extends React.Component
* @exported true
* @description the Add Card that gets shown at the bottom of account select drop down
*/
export function AddCardSelectItem(props) {
  const navigate = useRoute();
  const dataPoint = props.dataPoint ? { "data-point": props.dataPoint } : {};
  
  const onClick = evt => navigate("/addCardWorkflow");

  return (
    <div className="custom-card-select-item add-card-select-item" onClick={ onClick }>
      <div className="card-wrapper custom-select-item flex-container flex-horizontal"> 
        <div className="leftColumn set-width">
          <div className="card-outline-container flex-container align-center-container">
            <SVGAsset id="CirclePlusIcon" className="add-card-icon" />
          </div>
        </div>
        <div className="rightColumn flex-width" {...dataPoint}>
          <div className="card-name">Add Card</div>
        </div>  
      </div>
    </div>
  );
}